import { render } from "./FrontendUpdateNotice.vue?vue&type=template&id=0903c844&scoped=true"
import script from "./FrontendUpdateNotice.vue?vue&type=script&lang=js"
export * from "./FrontendUpdateNotice.vue?vue&type=script&lang=js"

import "./FrontendUpdateNotice.vue?vue&type=style&index=0&id=0903c844&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0903c844"]])

export default __exports__